module.exports = __webpack_public_path__ + "img/invite.e81ae0ad.webp";